
const 	$ = jQuery;

var sitekey = '6Lcug6gUAAAAABacZbik_bDf6cxxUIBu89gPD2FX',
	$tokenFields = $('.js-grtoken'),
	$allFormsOnPage = $('form'),
	twoMinutes = 120000,
	interval;


function applyTokenToTokenFields( token ) {
	$tokenFields.each(function(i, elem) {
		$(elem).val(token);
	});
}

function getRecaptchaToken() {
	return grecaptcha.execute(sitekey, {
		action: 'view'
	});
}

function getAndApplyToken() {
	getRecaptchaToken()
		.then(function(token) {
			applyTokenToTokenFields(token);
		});
}

if ( $allFormsOnPage.length && grecaptcha && $tokenFields.length ) {

	grecaptcha.ready(function() {

		getAndApplyToken();

		// token expires after two minutes so need to renew
		interval = window.setInterval( function() {
			getAndApplyToken();
		}, twoMinutes);

		$allFormsOnPage.each(function(i, elem) {
			$(elem).on('submit', function() {
				getAndApplyToken();
			});
		});
	});
}